import { render, staticRenderFns } from "./PermissionSelect.vue?vue&type=template&id=592e3f7f&scoped=true"
import script from "./PermissionSelect.vue?vue&type=script&lang=js"
export * from "./PermissionSelect.vue?vue&type=script&lang=js"
import style0 from "./PermissionSelect.vue?vue&type=style&index=0&id=592e3f7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592e3f7f",
  null
  
)

export default component.exports